function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "saved-board-toggle-on",
  d: "M-21.264.047H-33.707A1.267,1.267,0,0,0-34.985,1.3V13.792a1.235,1.235,0,0,0,.772,1.151,1.321,1.321,0,0,0,.513.1,1.278,1.278,0,0,0,.872-.345l5.3-4.914a.213.213,0,0,1,.288,0l5.1,4.727a1.28,1.28,0,0,0,1.385.24,1.237,1.237,0,0,0,.773-1.151V1.3A1.268,1.268,0,0,0-21.264.047Z",
  transform: "translate(35 0)",
  fill: "fill"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "saved-board-toggle-off",
  d: "M-68.665,15.047a1.325,1.325,0,0,1-.513-.1,1.237,1.237,0,0,1-.772-1.151V1.3A1.267,1.267,0,0,1-68.671.047h12.442A1.268,1.268,0,0,1-54.95,1.3V13.6a1.237,1.237,0,0,1-.773,1.151,1.281,1.281,0,0,1-1.385-.24l-5.1-4.727a.212.212,0,0,0-.286,0l-5.3,4.914A1.278,1.278,0,0,1-68.665,15.047ZM-68.671,1.1a.208.208,0,0,0-.209.2V13.792a.194.194,0,0,0,.125.187.2.2,0,0,0,.227-.039l5.3-4.913a1.3,1.3,0,0,1,1.757,0l5.1,4.725a.207.207,0,0,0,.227.04.2.2,0,0,0,.126-.189V1.3a.208.208,0,0,0-.209-.2Z",
  transform: "translate(69.95 -0.047)",
  fill: "fill"
});

function SvgIcoSavedBoardToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSavedBoardToggle);
export default __webpack_public_path__ + "static/media/ico_saved-board-toggle.9d11ac83.svg";
export { ForwardRef as ReactComponent };